import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  en: {
    // Common
    welcome: 'Welcome',
    dashboard: 'Dashboard',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    loading: 'Loading...',
    submit: 'Submit',
    back: 'Back',
    next: 'Continue',
    // Nav
    caregivers: 'Caregivers',
    clients: 'Clients',
    shifts: 'Shifts',
    messages: 'Messages',
    reports: 'Reports',
    settings: 'Settings',
    invitations: 'Invitations',
    timesheets: 'Timesheets',
    subscription: 'Subscription',
    analytics: 'Analytics',
    availability: 'Availability',
    wellnessGoals: 'Wellness Goals',
    videoCall: 'Video Call',
    // Dashboard
    totalCaregivers: 'Total Caregivers',
    totalClients: 'Total Clients',
    totalShifts: 'Total Shifts',
    pendingShifts: 'Pending Shifts',
    manageShifts: 'Manage Shifts',
    inviteUser: 'Invite User',
    // Auth
    email: 'Email',
    password: 'Password',
    registerAgency: 'Register Your Agency',
    welcomeBack: 'Welcome back',
    signInDesc: 'Sign in to access your dashboard',
    // Shifts
    checkIn: 'Check In',
    checkOut: 'Check Out',
    noShow: 'No Show',
    assigned: 'Assigned',
    completed: 'Completed',
    cancelled: 'Cancelled',
    inProgress: 'In Progress',
    // Subscription
    currentPlan: 'Current Plan',
    activeUsers: 'Active Users',
    renewal: 'Renewal',
    autoRenew: 'Auto-renew',
    paymentHistory: 'Payment History',
    // Emergency
    emergencyAssistance: 'Emergency Assistance',
    sendSOS: 'Send SOS Alert',
    // Timesheets
    generateTimesheets: 'Generate Timesheets',
    approve: 'Approve',
    reject: 'Reject',
    totalHours: 'Total Hours',
    totalPay: 'Total Pay',
    payslips: 'Payslips',
  },
  uk: {
    welcome: 'Ласкаво просимо',
    dashboard: 'Панель',
    signIn: 'Увійти',
    signOut: 'Вийти',
    save: 'Зберегти',
    cancel: 'Скасувати',
    delete: 'Видалити',
    edit: 'Редагувати',
    create: 'Створити',
    search: 'Пошук',
    loading: 'Завантаження...',
    submit: 'Надіслати',
    back: 'Назад',
    next: 'Далі',
    caregivers: 'Доглядачі',
    clients: 'Клієнти',
    shifts: 'Зміни',
    messages: 'Повідомлення',
    reports: 'Звіти',
    settings: 'Налаштування',
    invitations: 'Запрошення',
    timesheets: 'Табелі',
    subscription: 'Підписка',
    analytics: 'Аналітика',
    availability: 'Доступність',
    wellnessGoals: 'Цілі здоров\'я',
    videoCall: 'Відеодзвінок',
    totalCaregivers: 'Всього доглядачів',
    totalClients: 'Всього клієнтів',
    totalShifts: 'Всього змін',
    pendingShifts: 'Очікуючі зміни',
    manageShifts: 'Керувати змінами',
    inviteUser: 'Запросити',
    email: 'Електронна пошта',
    password: 'Пароль',
    registerAgency: 'Зареєструвати агентство',
    welcomeBack: 'З поверненням',
    signInDesc: 'Увійдіть для доступу до панелі',
    checkIn: 'Відмітитися',
    checkOut: 'Завершити',
    noShow: 'Неявка',
    assigned: 'Призначено',
    completed: 'Завершено',
    cancelled: 'Скасовано',
    inProgress: 'В процесі',
    currentPlan: 'Поточний план',
    activeUsers: 'Активні користувачі',
    renewal: 'Поновлення',
    autoRenew: 'Автоподовження',
    paymentHistory: 'Історія оплат',
    emergencyAssistance: 'Екстрена допомога',
    sendSOS: 'Надіслати SOS',
    generateTimesheets: 'Створити табелі',
    approve: 'Затвердити',
    reject: 'Відхилити',
    totalHours: 'Всього годин',
    totalPay: 'Всього оплата',
    payslips: 'Розрахункові листки',
  },
  ru: {
    welcome: 'Добро пожаловать',
    dashboard: 'Панель',
    signIn: 'Войти',
    signOut: 'Выйти',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    create: 'Создать',
    search: 'Поиск',
    loading: 'Загрузка...',
    submit: 'Отправить',
    back: 'Назад',
    next: 'Далее',
    caregivers: 'Сиделки',
    clients: 'Клиенты',
    shifts: 'Смены',
    messages: 'Сообщения',
    reports: 'Отчёты',
    settings: 'Настройки',
    invitations: 'Приглашения',
    timesheets: 'Табели',
    subscription: 'Подписка',
    analytics: 'Аналитика',
    availability: 'Доступность',
    wellnessGoals: 'Цели здоровья',
    videoCall: 'Видеозвонок',
    totalCaregivers: 'Всего сиделок',
    totalClients: 'Всего клиентов',
    totalShifts: 'Всего смен',
    pendingShifts: 'Ожидающие смены',
    manageShifts: 'Управление сменами',
    inviteUser: 'Пригласить',
    email: 'Эл. почта',
    password: 'Пароль',
    registerAgency: 'Регистрация агентства',
    welcomeBack: 'С возвращением',
    signInDesc: 'Войдите для доступа к панели',
    checkIn: 'Отметиться',
    checkOut: 'Завершить',
    noShow: 'Неявка',
    assigned: 'Назначено',
    completed: 'Завершено',
    cancelled: 'Отменено',
    inProgress: 'В процессе',
    currentPlan: 'Текущий план',
    activeUsers: 'Активные пользователи',
    renewal: 'Продление',
    autoRenew: 'Автопродление',
    paymentHistory: 'История платежей',
    emergencyAssistance: 'Экстренная помощь',
    sendSOS: 'Отправить SOS',
    generateTimesheets: 'Создать табели',
    approve: 'Одобрить',
    reject: 'Отклонить',
    totalHours: 'Всего часов',
    totalPay: 'Всего оплата',
    payslips: 'Расчётные листки',
  },
  fa: {
    welcome: 'خوش آمدید',
    dashboard: 'داشبورد',
    signIn: 'ورود',
    signOut: 'خروج',
    save: 'ذخیره',
    cancel: 'لغو',
    delete: 'حذف',
    edit: 'ویرایش',
    create: 'ایجاد',
    search: 'جستجو',
    loading: '...بارگذاری',
    submit: 'ارسال',
    back: 'بازگشت',
    next: 'ادامه',
    caregivers: 'مراقبان',
    clients: 'مشتریان',
    shifts: 'شیفت‌ها',
    messages: 'پیام‌ها',
    reports: 'گزارش‌ها',
    settings: 'تنظیمات',
    invitations: 'دعوت‌نامه‌ها',
    timesheets: 'کارنامه',
    subscription: 'اشتراک',
    analytics: 'تحلیل‌ها',
    availability: 'دسترسی',
    wellnessGoals: 'اهداف سلامتی',
    videoCall: 'تماس تصویری',
    totalCaregivers: 'کل مراقبان',
    totalClients: 'کل مشتریان',
    totalShifts: 'کل شیفت‌ها',
    pendingShifts: 'شیفت‌های معلق',
    manageShifts: 'مدیریت شیفت‌ها',
    inviteUser: 'دعوت',
    email: 'ایمیل',
    password: 'رمز عبور',
    registerAgency: 'ثبت آژانس',
    welcomeBack: 'خوش برگشتید',
    signInDesc: 'برای دسترسی به داشبورد وارد شوید',
    checkIn: 'ورود',
    checkOut: 'خروج',
    noShow: 'غیبت',
    assigned: 'تخصیص داده شده',
    completed: 'تکمیل شده',
    cancelled: 'لغو شده',
    inProgress: 'در حال انجام',
    currentPlan: 'طرح فعلی',
    activeUsers: 'کاربران فعال',
    renewal: 'تمدید',
    autoRenew: 'تمدید خودکار',
    paymentHistory: 'تاریخچه پرداخت',
    emergencyAssistance: 'کمک اضطراری',
    sendSOS: 'ارسال SOS',
    generateTimesheets: 'ایجاد کارنامه',
    approve: 'تأیید',
    reject: 'رد',
    totalHours: 'کل ساعات',
    totalPay: 'کل پرداخت',
    payslips: 'فیش حقوقی',
  },
  zh: {
    welcome: '欢迎',
    dashboard: '仪表板',
    signIn: '登录',
    signOut: '退出',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    create: '创建',
    search: '搜索',
    loading: '加载中...',
    submit: '提交',
    back: '返回',
    next: '继续',
    caregivers: '护理人员',
    clients: '客户',
    shifts: '班次',
    messages: '消息',
    reports: '报告',
    settings: '设置',
    invitations: '邀请',
    timesheets: '考勤表',
    subscription: '订阅',
    analytics: '分析',
    availability: '可用性',
    wellnessGoals: '健康目标',
    videoCall: '视频通话',
    totalCaregivers: '护理人员总数',
    totalClients: '客户总数',
    totalShifts: '总班次',
    pendingShifts: '待处理班次',
    manageShifts: '管理班次',
    inviteUser: '邀请用户',
    email: '电子邮件',
    password: '密码',
    registerAgency: '注册机构',
    welcomeBack: '欢迎回来',
    signInDesc: '登录以访问您的仪表板',
    checkIn: '签到',
    checkOut: '签退',
    noShow: '缺勤',
    assigned: '已分配',
    completed: '已完成',
    cancelled: '已取消',
    inProgress: '进行中',
    currentPlan: '当前计划',
    activeUsers: '活跃用户',
    renewal: '续订',
    autoRenew: '自动续订',
    paymentHistory: '支付历史',
    emergencyAssistance: '紧急援助',
    sendSOS: '发送SOS',
    generateTimesheets: '生成考勤表',
    approve: '批准',
    reject: '拒绝',
    totalHours: '总小时数',
    totalPay: '总薪资',
    payslips: '工资单',
  },
  hi: {
    welcome: 'स्वागत है',
    dashboard: 'डैशबोर्ड',
    signIn: 'साइन इन',
    signOut: 'साइन आउट',
    save: 'सहेजें',
    cancel: 'रद्द करें',
    delete: 'हटाएं',
    edit: 'संपादित करें',
    create: 'बनाएं',
    search: 'खोजें',
    loading: 'लोड हो रहा है...',
    submit: 'जमा करें',
    back: 'वापस',
    next: 'आगे',
    caregivers: 'देखभालकर्ता',
    clients: 'ग्राहक',
    shifts: 'शिफ्ट',
    messages: 'संदेश',
    reports: 'रिपोर्ट',
    settings: 'सेटिंग्स',
    invitations: 'आमंत्रण',
    timesheets: 'टाइमशीट',
    subscription: 'सदस्यता',
    analytics: 'विश्लेषण',
    availability: 'उपलब्धता',
    wellnessGoals: 'स्वास्थ्य लक्ष्य',
    videoCall: 'वीडियो कॉल',
    totalCaregivers: 'कुल देखभालकर्ता',
    totalClients: 'कुल ग्राहक',
    totalShifts: 'कुल शिफ्ट',
    pendingShifts: 'लंबित शिफ्ट',
    manageShifts: 'शिफ्ट प्रबंधन',
    inviteUser: 'आमंत्रित करें',
    email: 'ईमेल',
    password: 'पासवर्ड',
    registerAgency: 'एजेंसी पंजीकरण',
    welcomeBack: 'वापस स्वागत है',
    signInDesc: 'अपने डैशबोर्ड तक पहुँचने के लिए साइन इन करें',
    checkIn: 'चेक इन',
    checkOut: 'चेक आउट',
    noShow: 'अनुपस्थित',
    assigned: 'नियुक्त',
    completed: 'पूर्ण',
    cancelled: 'रद्द',
    inProgress: 'प्रगति में',
    currentPlan: 'वर्तमान योजना',
    activeUsers: 'सक्रिय उपयोगकर्ता',
    renewal: 'नवीनीकरण',
    autoRenew: 'स्वतः नवीनीकरण',
    paymentHistory: 'भुगतान इतिहास',
    emergencyAssistance: 'आपातकालीन सहायता',
    sendSOS: 'SOS भेजें',
    generateTimesheets: 'टाइमशीट बनाएं',
    approve: 'अनुमोदन',
    reject: 'अस्वीकार',
    totalHours: 'कुल घंटे',
    totalPay: 'कुल वेतन',
    payslips: 'वेतन पर्ची',
  }
};

const LANGUAGE_NAMES = {
  en: 'English',
  uk: 'Українська',
  ru: 'Русский',
  fa: 'فارسی',
  zh: '中文',
  hi: 'हिन्दी'
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [locale, setLocale] = useState(() => {
    return localStorage.getItem('fendanacura_lang') || 'en';
  });

  const changeLanguage = useCallback((lang) => {
    setLocale(lang);
    localStorage.setItem('fendanacura_lang', lang);
    // Set RTL for Farsi
    document.documentElement.dir = lang === 'fa' ? 'rtl' : 'ltr';
  }, []);

  const t = useCallback((key) => {
    return translations[locale]?.[key] || translations.en[key] || key;
  }, [locale]);

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage, t, languages: LANGUAGE_NAMES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
